import { Vue, Component, Watch } from 'vue-property-decorator';

// @ts-ignore
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

@Component({
	components: {
		VueSlickCarousel
	}
})

export default class clientsReviewsComponents extends Vue {

	clients = [{
		name: 'Mike May',
		src: 'MikeMay.jpeg',
		city: 'Toronto',
		review: 'Made my Garage and shed cleanout easy.\n' +
			'Delivery and pickup drivers were very courteous. Made sure my driveway was not damaged by the bin.\n' +
			'Company uses email and cell to communicate the status of pickup and delivery. Called me before dropping the bin.\n' +
			'Can\'t ask for better service - Highly recommended.\n'
	}, {
		name: 'Pearl Lande',
		city: 'Toronto',
		src: 'PearlLande.jpeg',
		review: 'Wonderful and pleasant service.  Our "Junk It" container was delivered and placed in the perfect spot as well as picked up and taken away as requested.  Very spacious and easy for our handyman to load all of our old flooring tiles.  So helpful to have a service like this.  Makes me want to clear out the rest of our garage, basement and barn!'
	}, {
		name: 'Adam Schieman',
		city: 'Burlington',
		src: 'AdamSchieman.jpeg',
		review: 'Always excellent and responsive service. Nice touch of putting down wood on the driveway so it doesn\'t get chewed up with the bin. The bin drop off and pickup was perfectly done, thanks 👍  I\'ll use your service again in a month or less for a second phase of renovations.'
	}]

	sliderSettings = {
		"centerMode": true,
		"dots": false,
		'arrows': true,
		"infinite": true,
		"speed": 500,
		"slidesToShow": 3,
		"slidesToScroll": 1,
		"centerPadding": "20px",
		"responsive": [
			{
				"breakpoint": 1200,
				"settings": {
					"slidesToShow": 2,
					"slidesToScroll": 1,
					"infinite": true,
				}
			},
			{
				"breakpoint": 800,
				"settings": {
					'arrows': true,
					"slidesToShow": 1,
					"slidesToScroll": 1
				}
			}
		]
	}

	get width() {
		if (this.size > 1250) {
			return 330
		}
		if (this.size = 1086) {
			return 380
		}
	}

	size = 0

	updateWidth() {
		this.size = window.innerWidth;
	}

	mounted() {

		window.addEventListener('resize', this.updateWidth);
	}

}
